// extracted by mini-css-extract-plugin
export default {"light":"tabeltemplate_light__7h4Ta","middle":"tabeltemplate_middle__PUyBK","hard":"tabeltemplate_hard__S2jSG"};